module.exports = __webpack_public_path__ + "static/img/s148.2f8c1515.png";